import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ACCESS_RIGHTS, Colors } from "../../config/Constants";
import ConfirmModal from "../Modal/ConfirmModal";
import { decryptItem } from "../../utils";

const NavigationBar = () => {
  const [isOpenLogout, setIsOpenLogout] = useState(false);
  const [user, setUser] = useState("");
  let navigate = useNavigate();
  const handleOnLogout = () => {
    setIsOpenLogout(false);
    localStorage.removeItem("userData");
    // localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/auth/login");
  };

  useEffect(() => {
    let { user: roleId } = decryptItem();
    let user = ACCESS_RIGHTS.filter(
      (role) => Number(role.key) === Number(roleId)
    );
    setUser(user[0].value);
  }, []);

  return (
    <StyledNavigationBar>
      <span>{user}</span>
      <StyledButton onClick={() => setIsOpenLogout(true)}>
        <img src={require("../../assets/images/logout.png")} alt="logout" />
      </StyledButton>
      {isOpenLogout && (
        <ConfirmModal
          heading="Confirm logout"
          subHeading="Are you sure you want to logout?"
          button1Label="Cancel"
          button2Label="Yes"
          button1Submit={() => setIsOpenLogout(false)}
          button2Submit={handleOnLogout}
          setOpenOrClose={setIsOpenLogout}
        />
      )}
    </StyledNavigationBar>
  );
};

const StyledNavigationBar = styled.nav`
  height: 2.5rem;
  padding: 1rem 3rem;
  display: flex;
  align-items: center;
  color: ${Colors.black};
  font-family: "Poppins-Bold";
  font-size: 1.5rem;
  justify-content: space-between;
  align-items: center;
  > button {
    background: transparent;
    border: none;
  }
  > button > img {
    height: 2.5rem;
    width: 2.5rem;
  }
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;
const StyledButton = styled.button`
  cursor: pointer;
`;

export default NavigationBar;
